import { Button } from 'antd';
import styled from 'styled-components';
import { COLOR, RADIUS } from '../../../constants/theme';

const OutlineButton = styled(Button)`
  &&& {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 48px;
    padding: 0 24px;
    border: 1px solid ${COLOR.primary};
    border-radius: ${RADIUS.md};
    background: transparent;
    color: ${COLOR.primary};
    font-size: 15px;
    font-weight: 500;
    box-shadow: none;

    &:hover,
    &:focus {
      border-color: ${COLOR.primary};
      background: ${COLOR.primaryLight};
      color: ${COLOR.primary};
    }
  }
`;

export default OutlineButton;
